module.exports = __webpack_public_path__ + "images/application/i-help-8732b84e.svg";